import { httpRequest } from "@services/http";
import { SegmentPopulation } from "@models/population.model";

/** Hold a percentage of the population's treatment out of one channel (MPN-2060). */
export class CommandSetSegmentChannelHoldout {
  async run(
    populationSegmentId: number,
    channel: string,
    enabled: boolean,
    pct: number,
  ): Promise<SegmentPopulation> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/populations/${populationSegmentId}/channel-holdouts/`;
    return httpRequest<SegmentPopulation>(url, { method: "POST", body: { channel, enabled, pct } });
  }
}
